import React from 'react'
import { useTranslation } from '@mc/i18n'
import { Timeline } from './Timeline'

export interface TimelineProps {
  featuredSession: {
    modules: {
      id: string
      name: string
      marketing3x2: string
    }[]
  }
}

export const TimelineSection = ({ featuredSession }: TimelineProps) => {
  const { t } = useTranslation('@mc/next')

  if (!featuredSession) return null

  return (
    <section className='container mc-px-0 mc-my-12'>
      <div className='row justify-content-center'>
        <div className='col-12 col-lg-8'>
          <h2 className='mc-text-h1 mc-text--center mc-mb-11'>
            {t('sessions.timelineSection.header')}
          </h2>
        </div>
      </div>

      <Timeline featuredSession={featuredSession} />
    </section>
  )
}
